export const SortByOptions = [
  { value: '0', label: 'Last, First Name' },
  { value: '1', label: 'Serving #' },
  { value: '2', label: 'Student #' },
];



// WEBPACK FOOTER //
// ./src/pages/specialmessage/constants/index.js